<cl-table [columns]="columns()" [sort]="sort()" (sortChange)="onSort($event)" [empty]="rows().length === 0" [emptyMessage]="'common.table.empty' | translate">
    <ng-content />
</cl-table>

<cl-paginator
    #paginator
    [total]="total()"
    [page]="page()"
    [pageSize]="limit()"
    [pageSizeOptions]="rowsPerPageOptions()"
    [report]="'common.table.pagination' | translate"
    (pageChange)="onPage($event, paginator.pageSize())"
    (pageSizeChange)="onLimit($event)"
/>
